{
  "$schema": "../../../../../../json-schemas/dashboard/dashboard-schema.json",
  "version": "1.0.0",
  "componentType": "public-document",
  "config": {
    "slots": {
      "content": {
        "componentType": "grid",
        "dataSource": {
          "type": "document-link"
        },
        "config": {
          "density": "comfortable",
          "tiles": [
            {
              "id": "summary",
              "componentType": "tile-default-layout",
              "preset": "standard",
              "size": "full",
              "dataSource": {
                "key": "document"
              },
              "config": {
                "slots": {
                  "headerLeft": {
                    "componentType": "text",
                    "config": {
                      "text": "PUBLIC_DOCUMENT_VIEW.SUMMARY.TITLE"
                    }
                  },
                  "headerRight": {
                    "componentType": "image-link",
                    "preset": "standard",
                    "showIf": {
                      "path": "$data.isEInvoice"
                    },
                    "actions": {
                      "open": {
                        "type": "track-event",
                        "config": {
                          "event": "DocumentViewVerifiedSupplierClicked",
                          "properties": {
                            "documentId": "$context.documentId"
                          }
                        }
                      }
                    },
                    "config": {
                      "src": "assets/img/Badge_eFA_VerifiedSupplier.svg",
                      "alt": "PUBLIC_DOCUMENT_VIEW.SUMMARY.VERIFIED_SUPPLIER",
                      "href": "https://www.kros.sk/efaktura?utm_campaign=425703665-Digi-doklad&utm_source=digi_doklad&utm_medium=verified_supplier_badge"
                    }
                  },
                  "content": {
                    "componentType": "stack",
                    "preset": "standard",
                    "config": {
                      "gap": "7",
                      "items": [
                        {
                          "componentType": "value-number",
                          "preset": "standard",
                          "config": {
                            "valuePath": "$data.payableAmount",
                            "currencyPath": "$data.currency",
                            "size": "5xl"
                          }
                        },
                        {
                          "componentType": "stack",
                          "preset": "standard",
                          "config": {
                            "gap": "3",
                            "items": [
                              {
                                "componentType": "labeled-value",
                                "preset": "standard",
                                "showIf": {
                                  "path": "$data.supplier.address.businessName"
                                },
                                "config": {
                                  "slots": {
                                    "label": {
                                      "componentType": "text",
                                      "config": {
                                        "text": "PUBLIC_DOCUMENT_VIEW.SUMMARY.LABEL_SENDER"
                                      }
                                    },
                                    "value": {
                                      "componentType": "value-string",
                                      "preset": "standard",
                                      "config": {
                                        "valuePath": "$data.supplier.address.businessName",
                                        "size": "md"
                                      }
                                    }
                                  }
                                }
                              },
                              {
                                "componentType": "divider",
                                "preset": "standard"
                              },
                              {
                                "componentType": "labeled-value",
                                "preset": "standard",
                                "showIf": {
                                  "path": "$data.documentNumber"
                                },
                                "config": {
                                  "slots": {
                                    "label": {
                                      "componentType": "text",
                                      "config": {
                                        "text": "PUBLIC_DOCUMENT_VIEW.SUMMARY.LABEL_NUMBER"
                                      }
                                    },
                                    "value": {
                                      "componentType": "value-string",
                                      "preset": "standard",
                                      "config": {
                                        "valuePath": "$data.documentNumber",
                                        "size": "md",
                                        "icon": "fa-light fa-file-invoice"
                                      }
                                    }
                                  }
                                }
                              },
                              {
                                "componentType": "labeled-value",
                                "preset": "standard",
                                "showIf": {
                                  "path": "$data.issueDate"
                                },
                                "config": {
                                  "slots": {
                                    "label": {
                                      "componentType": "text",
                                      "config": {
                                        "text": "PUBLIC_DOCUMENT_VIEW.SUMMARY.LABEL_ISSUED"
                                      }
                                    },
                                    "value": {
                                      "componentType": "value-date",
                                      "preset": "standard",
                                      "config": {
                                        "valuePath": "$data.issueDate",
                                        "size": "md",
                                        "icon": "fa-light fa-calendar"
                                      }
                                    }
                                  }
                                }
                              },
                              {
                                "componentType": "labeled-value",
                                "preset": "standard",
                                "showIf": {
                                  "path": "$data.dueDate"
                                },
                                "config": {
                                  "slots": {
                                    "label": {
                                      "componentType": "text",
                                      "config": {
                                        "text": "PUBLIC_DOCUMENT_VIEW.SUMMARY.LABEL_DUE"
                                      }
                                    },
                                    "value": {
                                      "componentType": "value-date",
                                      "preset": "standard",
                                      "config": {
                                        "valuePath": "$data.dueDate",
                                        "size": "md",
                                        "icon": "fa-light fa-clock"
                                      }
                                    }
                                  }
                                }
                              }
                            ]
                          }
                        }
                      ]
                    },
                    "states": {
                      "loading": {
                        "componentType": "spinner"
                      }
                    }
                  }
                }
              }
            },
            {
              "id": "primary-actions",
              "componentType": "tile-default-layout",
              "preset": "standard",
              "size": "full",
              "showIf": {
                "path": "$data.document.purchaser.registrationId"
              },
              "dataSource": {
                "key": "document"
              },
              "config": {
                "slots": {
                  "headerLeft": {
                    "componentType": "text",
                    "config": {
                      "text": "PUBLIC_DOCUMENT_VIEW.PRIMARY_ACTIONS.CARD_TITLE"
                    }
                  },
                  "content": {
                    "componentType": "primary-actions"
                  }
                }
              }
            },
            {
              "id": "payment",
              "componentType": "tile-default-layout",
              "preset": "standard",
              "size": "full",
              "dataSource": {
                "key": "payment"
              },
              "actions": {
                "pay": {
                  "type": "payme-redirect",
                  "config": {
                    "paymentData": "$data.paymentData"
                  }
                },
                "track-pay": {
                  "type": "track-event",
                  "config": {
                    "event": "DocumentViewPayClicked",
                    "properties": {
                      "documentId": "$context.documentId",
                      "source": "paymentTile"
                    }
                  }
                },
                "copy": {
                  "type": "copy-to-clipboard",
                  "config": {
                    "text": "$data.copyText"
                  }
                },
                "track-copy": {
                  "type": "track-event",
                  "config": {
                    "event": "DocumentViewCopyDetailsClicked",
                    "properties": {
                      "documentId": "$context.documentId"
                    }
                  }
                }
              },
              "config": {
                "slots": {
                  "headerLeft": {
                    "componentType": "text",
                    "config": {
                      "text": "PUBLIC_DOCUMENT_VIEW.TILE_TITLE.PAYMENT"
                    }
                  },
                  "content": {
                    "componentType": "stack",
                    "preset": "standard",
                    "config": {
                      "direction": "column",
                      "gap": "2",
                      "items": [
                        {
                          "componentType": "text",
                          "showIf": {
                            "path": "$data.isSettled"
                          },
                          "config": {
                            "text": "PUBLIC_DOCUMENT_VIEW.PAYMENT.LABEL_ALREADY_PAID",
                            "icon": "fa-circle-info",
                            "weight": "semibold"
                          }
                        },
                        {
                          "componentType": "action",
                          "preset": "standard",
                          "showIf": {
                            "not": {
                              "path": "$data.isSettled"
                            }
                          },
                          "actionsMap": {
                            "click": ["pay", "track-pay"]
                          },
                          "config": {
                            "label": "PUBLIC_DOCUMENT_VIEW.PAYMENT.BUTTON_PAY",
                            "icon": "fa-light fa-credit-card",
                            "disabledIf": {
                              "not": {
                                "path": "$data.canPay"
                              }
                            }
                          }
                        },
                        {
                          "componentType": "action",
                          "preset": "standard",
                          "showIf": {
                            "not": {
                              "path": "$data.isSettled"
                            }
                          },
                          "actionsMap": {
                            "click": ["copy", "track-copy"]
                          },
                          "config": {
                            "label": "PUBLIC_DOCUMENT_VIEW.PAYMENT.BUTTON_COPY",
                            "icon": "fa-light fa-copy",
                            "disabledIf": {
                              "not": {
                                "path": "$data.canPay"
                              }
                            },
                            "variant": "secondary"
                          }
                        }
                      ]
                    },
                    "states": {
                      "loading": {
                        "componentType": "spinner"
                      }
                    }
                  }
                }
              }
            },
            {
              "id": "document",
              "componentType": "tile-default-layout",
              "preset": "standard",
              "size": "full",
              "dataSource": {
                "key": "preview"
              },
              "actions": {
                "share": {
                  "type": "mailto",
                  "config": {
                    "subject": "PUBLIC_DOCUMENT_VIEW.EFAKTURA_ACTIONS.SHARE_EMAIL_SUBJECT",
                    "body": "PUBLIC_DOCUMENT_VIEW.EFAKTURA_ACTIONS.SHARE_EMAIL_BODY"
                  }
                },
                "track-share": {
                  "type": "track-event",
                  "config": {
                    "event": "DocumentViewShareByEmailClicked",
                    "properties": {
                      "documentId": "$context.documentId",
                      "source": "documentTile"
                    }
                  }
                },
                "print": {
                  "type": "document-print-pdf",
                  "config": {
                    "documentPath": "$data.document"
                  }
                },
                "track-print": {
                  "type": "track-event",
                  "config": {
                    "event": "DocumentViewPrintClicked",
                    "properties": {
                      "documentId": "$context.documentId"
                    }
                  }
                },
                "download-pdf": {
                  "type": "document-download-pdf",
                  "config": {
                    "documentPath": "$data.document"
                  }
                },
                "track-download-pdf": {
                  "type": "track-event",
                  "config": {
                    "event": "DocumentViewPdfDownloadClicked",
                    "properties": {
                      "documentId": "$context.documentId"
                    }
                  }
                },
                "view-xml": {
                  "type": "open-modal",
                  "config": {
                    "modalId": "efaktura-xml"
                  }
                },
                "track-view-xml": {
                  "type": "track-event",
                  "config": {
                    "event": "DocumentViewEfakturaViewerOpened",
                    "properties": {
                      "documentId": "$context.documentId"
                    }
                  }
                },
                "close-xml": {
                  "type": "close-modal",
                  "config": {
                    "modalId": "efaktura-xml"
                  }
                },
                "download-xml": {
                  "type": "einvoice-download-xml",
                  "config": {
                    "documentPath": "$data.document"
                  }
                },
                "track-download-xml": {
                  "type": "track-event",
                  "config": {
                    "event": "DocumentViewEfakturaDownloadClicked",
                    "properties": {
                      "documentId": "$context.documentId"
                    }
                  }
                },
                "pdf-failed": {
                  "type": "document-pdf-failed"
                },
                "pdf-retry": {
                  "type": "document-pdf-retry"
                }
              },
              "modals": {
                "efaktura-xml": {
                  "componentType": "efaktura-xml-viewer",
                  "showIf": {
                    "path": "$data.hasXmlActions"
                  },
                  "inUrl": "always",
                  "actionsMap": {
                    "close": "close-xml"
                  },
                  "config": {
                    "documentPath": "$source.data.document"
                  }
                }
              },
              "config": {
                "slots": {
                  "headerLeft": {
                    "componentType": "text",
                    "config": {
                      "text": "PUBLIC_DOCUMENT_VIEW.TILE_TITLE.INVOICE",
                      "textPath": "$data.titleKey"
                    }
                  },
                  "headerRight": {
                    "componentType": "stack",
                    "preset": "standard",
                    "config": {
                      "direction": "row",
                      "gap": "2",
                      "align": "center",
                      "items": [
                        {
                          "componentType": "action",
                          "preset": "standard",
                          "showIf": {
                            "not": {
                              "path": "$data.document.isDeleted"
                            }
                          },
                          "actionsMap": {
                            "click": ["share", "track-share"]
                          },
                          "config": {
                            "variant": "link",
                            "icon": "fa-light fa-envelope",
                            "ariaLabel": "PUBLIC_DOCUMENT_VIEW.EFAKTURA_ACTIONS.SHARE_BY_EMAIL"
                          }
                        },
                        {
                          "componentType": "action",
                          "preset": "standard",
                          "showIf": {
                            "path": "$data.hasPdfActions"
                          },
                          "actionsMap": {
                            "click": ["print", "track-print"]
                          },
                          "config": {
                            "variant": "link",
                            "icon": "fa-light fa-print",
                            "ariaLabel": "PUBLIC_DOCUMENT_VIEW.EFAKTURA_ACTIONS.PRINT"
                          }
                        },
                        {
                          "componentType": "action",
                          "preset": "standard",
                          "showIf": {
                            "path": "$data.hasPdfActions"
                          },
                          "actionsMap": {
                            "click": ["download-pdf", "track-download-pdf"]
                          },
                          "config": {
                            "variant": "link",
                            "icon": "fa-light fa-download",
                            "label": "PUBLIC_DOCUMENT_VIEW.EFAKTURA_ACTIONS.DOWNLOAD_PDF"
                          }
                        },
                        {
                          "componentType": "action",
                          "preset": "standard",
                          "showIf": {
                            "path": "$data.hasXmlActions"
                          },
                          "actionsMap": {
                            "click": ["view-xml", "track-view-xml"]
                          },
                          "config": {
                            "variant": "link",
                            "icon": "fa-light fa-eye",
                            "label": "PUBLIC_DOCUMENT_VIEW.EFAKTURA_ACTIONS.VIEW_XML"
                          }
                        },
                        {
                          "componentType": "action",
                          "preset": "standard",
                          "showIf": {
                            "path": "$data.hasXmlActions"
                          },
                          "actionsMap": {
                            "click": ["download-xml", "track-download-xml"]
                          },
                          "config": {
                            "variant": "secondary",
                            "icon": "fa-light fa-download",
                            "label": "PUBLIC_DOCUMENT_VIEW.EFAKTURA_ACTIONS.DOWNLOAD_XML"
                          }
                        }
                      ]
                    }
                  },
                  "content": {
                    "componentType": "stack",
                    "preset": "standard",
                    "states": {
                      "loading": {
                        "componentType": "spinner"
                      }
                    },
                    "config": {
                      "gap": "3",
                      "items": [
                        {
                          "componentType": "alert",
                          "preset": "standard",
                          "showIf": {
                            "all": [
                              {
                                "not": {
                                  "path": "$data.document.isDeleted"
                                }
                              },
                              {
                                "path": "$data.isNotTaxDocument"
                              }
                            ]
                          },
                          "config": {
                            "tone": "warning",
                            "icon": "fa-circle-info",
                            "description": "PUBLIC_DOCUMENT_VIEW.DOCUMENT_PREVIEW.NOT_TAX_DOCUMENT_NOTICE"
                          }
                        },
                        {
                          "componentType": "blank-page",
                          "showIf": {
                            "path": "$data.document.isDeleted"
                          },
                          "config": {
                            "watermark": "PUBLIC_DOCUMENT_VIEW.DOCUMENT_PREVIEW.DELETED_WATERMARK",
                            "watermarkTone": "danger"
                          }
                        },
                        {
                          "componentType": "pdf-viewer",
                          "showIf": {
                            "all": [
                              {
                                "not": {
                                  "path": "$data.document.isDeleted"
                                }
                              },
                              {
                                "path": "$data.isNotTaxDocument"
                              }
                            ]
                          },
                          "dataSource": {
                            "type": "document-pdf",
                            "documentPath": "$data.document"
                          },
                          "actionsMap": {
                            "loadFailed": "pdf-failed"
                          },
                          "states": {
                            "loading": {
                              "componentType": "spinner"
                            },
                            "error": {
                              "componentType": "blank-page",
                              "config": {
                                "watermark": "PUBLIC_DOCUMENT_VIEW.DOCUMENT_PREVIEW.PDF_WATERMARK"
                              }
                            },
                            "error-pdf-failed": {
                              "componentType": "alert",
                              "preset": "standard",
                              "config": {
                                "tone": "warning",
                                "icon": "fa-circle-exclamation",
                                "description": "PUBLIC_DOCUMENT_VIEW.DOCUMENT_PREVIEW.LOAD_FAILED_NOTICE",
                                "slots": {
                                  "action": {
                                    "componentType": "action",
                                    "preset": "standard",
                                    "actionsMap": {
                                      "click": "pdf-retry"
                                    },
                                    "config": {
                                      "variant": "outline-primary",
                                      "label": "PUBLIC_DOCUMENT_VIEW.DOCUMENT_PREVIEW.LOAD_FAILED_RETRY"
                                    }
                                  }
                                }
                              }
                            }
                          },
                          "config": {
                            "srcPath": "$data.src",
                            "watermark": "PUBLIC_DOCUMENT_VIEW.DOCUMENT_PREVIEW.PDF_WATERMARK"
                          }
                        },
                        {
                          "componentType": "pdf-viewer",
                          "showIf": {
                            "all": [
                              {
                                "not": {
                                  "path": "$data.document.isDeleted"
                                }
                              },
                              {
                                "not": {
                                  "path": "$data.isNotTaxDocument"
                                }
                              }
                            ]
                          },
                          "dataSource": {
                            "type": "document-pdf",
                            "documentPath": "$data.document"
                          },
                          "actionsMap": {
                            "loadFailed": "pdf-failed"
                          },
                          "states": {
                            "loading": {
                              "componentType": "spinner"
                            },
                            "error": {
                              "componentType": "blank-page"
                            },
                            "error-pdf-failed": {
                              "componentType": "alert",
                              "preset": "standard",
                              "config": {
                                "tone": "warning",
                                "icon": "fa-circle-exclamation",
                                "description": "PUBLIC_DOCUMENT_VIEW.DOCUMENT_PREVIEW.LOAD_FAILED_NOTICE",
                                "slots": {
                                  "action": {
                                    "componentType": "action",
                                    "preset": "standard",
                                    "actionsMap": {
                                      "click": "pdf-retry"
                                    },
                                    "config": {
                                      "variant": "outline-primary",
                                      "label": "PUBLIC_DOCUMENT_VIEW.DOCUMENT_PREVIEW.LOAD_FAILED_RETRY"
                                    }
                                  }
                                }
                              }
                            }
                          },
                          "config": {
                            "srcPath": "$data.src"
                          }
                        }
                      ]
                    }
                  }
                }
              }
            },
            {
              "id": "promo",
              "componentType": "tile-default-layout",
              "preset": "standard",
              "size": "full",
              "surface": "transparent",
              "config": {
                "slots": {
                  "content": {
                    "componentType": "promo"
                  }
                }
              }
            }
          ]
        }
      }
    }
  }
}
